import React, {Fragment, useState} from "react";
import NotificationsIcon from "@material-ui/icons/Notifications";
import {createStyles, makeStyles} from "@material-ui/core/styles";
import {Badge, IconButton} from "@material-ui/core";
import NotificationsDrawer from "./NotificationsDrawer";
import {useUserProvider} from "../../providers/UserProvider";
import { useNotificationsProvider } from "../../providers/NotificationsProvider";
import { useMfwThemeProvider } from "myfitworld-utils";

const useStyles = makeStyles(() =>
  createStyles({
    notification: {
      color: "white",
    },
  })
);
const NotificationButton = () => {
  const classes = useStyles();
  const theme = useMfwThemeProvider();
  const [isOpen, setOpen] = useState(false);
  const {unreadCount} = useNotificationsProvider();
  const handleMessages = () => {
    setOpen((prevState) => !prevState);
  };
  return (
    <Fragment>
      <IconButton onClick={handleMessages}>
        <Badge badgeContent={unreadCount} color="error">
          <NotificationsIcon style={{color:theme.mfwMuiWebTheme.palette.text.primary}} className={classes.notification}/>
        </Badge>
      </IconButton>
      {isOpen && <NotificationsDrawer isOpen={isOpen} onClose={handleMessages}/>}
    </Fragment>
  );
};

export default NotificationButton;
